<app-modal-dialog (backdropClick)="close()" data-testid="metadata-help-dialog">
  <div header>{{ 'formBuilder.textLabel.metadataHelp.title' | translate }}</div>
  <div content>
    <p>{{ 'formBuilder.textLabel.metadataHelp.intro' | translate }}</p>
    <table class="metadata-fields-table" data-testid="metadata-fields-table">
      <tbody>
        @for (field of metadataFields; track field.key) {
        <tr>
          <td class="metadata-field-key"><code>{{ '{{' + field.key + '}}' }}</code></td>
          <td>{{ field.description | translate }}</td>
        </tr>
        }
      </tbody>
    </table>
    <p class="metadata-example">
      {{ 'formBuilder.textLabel.metadataHelp.exampleLabel' | translate }}
      <code>{{ 'formBuilder.textLabel.metadataHelp.exampleTemplate' | translate }}</code>
    </p>
  </div>
  <div footer>
    <app-button variant="text" (click)="close()" data-testid="metadata-help-close">
      {{ 'button.close' | translate }}
    </app-button>
  </div>
</app-modal-dialog>
